import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import type { Props as ButtonProps, Color } from 'atoms/buttons/Button';
import { Button } from 'atoms/buttons/Button';
import { useIsLoggedIn } from 'hooks/auth/useIsLoggedIn';
import { useToggleSubscription } from 'hooks/subscriptions/useToggleSubscription';
import { useLoggedCallback } from 'hooks/useLoggedCallback';
import { fantasy, glossary } from 'lib/glossary';
import { isType } from 'lib/gql';

interface Props
  extends Omit<ButtonProps, 'onChange' | 'classes' | 'onClick' | 'size'> {
  currentUserSubscription: { slug: string } | null | undefined;
  subscribable: { __typename: string; slug: string };
  onChange?: (value: boolean) => void;
  onClick?: (value: boolean) => void;
}

const Root = styled(Button)`
  &.stroke {
    background-color: white;
  }
`;

export const FollowButton = (props: Props) => {
  const {
    currentUserSubscription,
    subscribable,
    onChange,
    onClick,
    className,
    ...rest
  } = props;
  const isLoggedIn = useIsLoggedIn();
  const [hover, setHover] = useState(false);
  const toggleSubscription = useToggleSubscription(
    currentUserSubscription,
    subscribable
  );
  const callback = () => {
    onChange?.(!currentUserSubscription);
    toggleSubscription();
  };
  const loggedToggleSubscription = useLoggedCallback(callback, true, true);

  let btnColor: Color = 'secondary';
  if (currentUserSubscription && hover) {
    btnColor = 'red';
  } else if (currentUserSubscription) {
    btnColor = 'quaternary';
  }

  return (
    <Root
      onClick={e => {
        onClick?.(!currentUserSubscription);
        loggedToggleSubscription(e);
      }}
      className={className}
      color={btnColor}
      size="medium"
      onMouseEnter={() => {
        if (currentUserSubscription) setHover(true);
      }}
      onMouseLeave={() => {
        if (currentUserSubscription) setHover(false);
      }}
      blur
      {...rest}
    >
      {isLoggedIn ? (
        <span>
          {isType(subscribable, 'User') ? (
            <>
              {currentUserSubscription ? (
                <FormattedMessage
                  {...(hover ? fantasy.removeCircle : fantasy.inCircle)}
                />
              ) : (
                <FormattedMessage {...fantasy.addCircle} />
              )}
            </>
          ) : (
            <>
              {currentUserSubscription ? (
                <FormattedMessage
                  {...(hover ? glossary.unfollow : glossary.following)}
                />
              ) : (
                <FormattedMessage {...glossary.follow} />
              )}
            </>
          )}
        </span>
      ) : (
        <span>
          <FormattedMessage {...glossary.playNow} />
        </span>
      )}
    </Root>
  );
};
